export default __webpack_public_path__ + "static/media/sun.d556e2de.png";